import { useCallback, useEffect } from "react"

import { useTableContext } from "./context"

export const useColumnWidth = ({ columnIndex }) => {
  const { columnWidths } = useTableContext()

  const width = columnWidths[columnIndex]
  if (!width) return undefined

  const pixelWidth = `${width}px`
  return { width: pixelWidth, minWidth: pixelWidth, maxWidth: pixelWidth }
}

export const useStopResizing = ({ dragStateRef, setActiveResizeColumn, onMouseMove }) => {
  const stopResizing = useCallback(() => {
    dragStateRef.current = null
    setActiveResizeColumn(null)
    document.body.style.removeProperty('cursor')
    document.body.style.removeProperty('user-select')
    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('mouseup', stopResizing)
  }, [dragStateRef, onMouseMove, setActiveResizeColumn])

  useEffect(() => () => stopResizing(), [stopResizing])

  return stopResizing
}

export const handleMouseMove = ({ event, dragStateRef, setColumnWidths }) => {
  const dragState = dragStateRef.current
  if (!dragState) return

  const delta = event.clientX - dragState.startX
  const nextWidth = Math.max(dragState.minWidth, Math.round(dragState.startWidth + delta))

  setColumnWidths(widths => {
    if (widths[dragState.columnIndex] === nextWidth) return widths
    return { ...widths, [dragState.columnIndex]: nextWidth }
  })
}
